/* eslint-disable */

import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';
import { Technology } from '../FbbEnum';
import * as wording from '../../../common/js/wording';

export class AddOn {
	protected key: string = 'AddOn'; //map to addonV2.json's id field
	protected elementId: string = ''; //GTM

	protected boxIconEn: string = '';
	protected boxIconZh: string = '';
	protected boxNameEn: string = '';
	protected boxNameZh: string = '';
	protected boxAmount: number = 0;
	protected boxCount: Number = 0;
	protected discountAmount: Number = -1;
	protected hasRedCounter = false;

	/*
    protected landingIcon:{en:string, zh:string} = {en:'', zh:''}
    protected landingTitle:{en:string, zh:string} = {en:'', zh:''}
    protected landingDesc1:{en:string, zh:string} = {en:'', zh:''}
    protected landingDesc2:{en:string, zh:string} = {en:'', zh:''}
    */
	protected json: any = {}; //addonV2.json

	protected type: AddOnType = AddOnType.SINGLE;

	//=================================================================================

	//override at sub class please
	public isAddOnSelected(): boolean {
		return false;
	}
	public getKey(): string {
		return this.key + '';
	}
	public isShowRedCounter() {
		return this.hasRedCounter;
	}

	public getData(): any {
		return {
			key: this.key,
		};
	}
	public parse(data: any) {
		this.key = data.key;
	}

	public getName(lang: string) {
		return this.getLandingBoxTitle(lang);
	}

	public getShortName(lang: string) {
		return this.getLandingBoxShortTitle();
	}

	public getIconPath(lang: string) {
		return this.getLandingBoxIconPath();
	}

	public getContractMonth(
		tech: String | null,
		buildingType: String | null,
		contractMonth: String | null
	): Number {
		return 0;
	}

	public getAmount(contractMonth: String | null): Number {
		return this.boxAmount;
	}

	public getDiscountAmount(): Number {
		return this.discountAmount;
	}

	public getSelectedCount(): Number {
		return this.boxCount;
	}

	public setSelectedCount(count: Number) {
		this.boxCount = count;
	}

	public getAddOnType(): AddOnType {
		return this.type;
	}

	//parse config.json
	public parseConfig(json: any | null) {
		this.json = json ?? {};
	}

	public getLandingElementId(): string {
		var box = this.json['box'] ?? {};
		//log.ot('getElementId', box)
		return box['elementId'] ?? '';
	}

	public getSelectPlanElementId(): string {
		var box = this.json['box'] ?? {};
		//log.ot('getElementId', box)
		return box['planElementId'] ?? '';
	}

	public getLandingBoxIconPath(): string {
		var box = this.json['box'] ?? {};
		return wording.get(box['icon'] ?? '');
	}

	public getA2BoxIconPath(): string {
		var box = this.json['box'] ?? {};
		var icon = box['icon'];
		var iconA2 = box['icon_a2'];
		return wording.get(iconA2 ?? icon ?? '');
	}

	public getLandingBoxTitle(lang: string): string {
		var box = this.json['box'] ?? {};
		if (lang == wording.ENGLISH) {
			return (box['title'] ?? '')['en'];
		} else if (lang == wording.CHINESE) {
			return (box['title'] ?? '')['zh'];
		}
		return wording.get(box['title'] ?? '');
	}
	public getLandingBoxShortTitle(): string {
		var box = this.json['box'] ?? {};
		return wording.get(box['shorttitle'] ?? '');
	}

	public getLandingBoxItemBySpecialKey(tncKey: string): string {
		var box = this.json['box'] ?? {};
		return wording.get(box[tncKey + ''] ?? '');
	}

	public getLandingBoxDesc1(): string {
		var box = this.json['box'] ?? {};
		return wording.get(box['desc1'] ?? '');
	}
	public getLandingBoxDesc2(): string {
		var box = this.json['box'] ?? {};
		return wording.get(box['desc2'] ?? '');
	}
	public getLandingBoxUrl(): string {
		var box = this.json['box'] ?? {};
		return wording.get(box['url'] ?? '');
	}

	public getLandingDetailsIcon(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['icon'] ?? '');
	}

	public getA2DetailsIcon(): string {
		var box = this.json['details'] ?? {};
		var icon = box['icon'];
		var iconA2 = box['icon_a2'];
		return wording.get(iconA2 ?? icon ?? '');
	}

	public getLandingDetailsTitle(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['title'] ?? '');
	}

	public getA2AddOnDetailsTitle(): string {
		var box = this.json['details'] ?? {};
		let a2Tilte = box.hasOwnProperty('title_a2') ? box['title_a2'] : box['title'];
		return wording.get(a2Tilte ?? '');
	}

	public getLandingDetailsSubtitle(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['subtitle'] ?? '');
	}

	public getLandingDetailsDescHtml(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['descHtml'] ?? '');
	}

	public getLandingDetailsDescHtmlLanding(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['descHtmlLanding'] ?? '');
	}

	public getLandingDetailsHaveTnc(): boolean {
		var box = this.json['details'] ?? {};
		return box['haveTnc'] ?? false;
	}

	public getLandingAndroidLink(): string {
		var box = this.json['details'] ?? {};
		return box['androidLink'] ?? {};
	}
	public getLandingIosLink(): string {
		var box = this.json['details'] ?? {};
		return box['iosLink'] ?? {};
	}

	public getLandingDetailsTnc(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['tncHtml'] ?? '');
	}

	public getA2AddOnDetailsItemBySpecialKey(tncKey: string): string {
		var box = this.json['details'] ?? {};
		return wording.get(box[tncKey + ''] ?? '');
	}

	public isAddOnDetailsItemExistBySpecialKey(parentKey: string): boolean {
		// parentKey: planCode
		let isExist = false;
		var box = this.json['details'][parentKey] ?? {};
		isExist =
			box.hasOwnProperty('title') || box.hasOwnProperty('tncHtml') || box.hasOwnProperty('descHtml');
		return isExist;
	}

	public getAddOnDetailsItemBySpecialKey(parentKey: string, childKey: string): string {
		// parentKey: planCode
		var box = this.json['details'][parentKey] ?? {};
		return wording.get(box[childKey + ''] ?? '');
	}

	public getTncLinkList(): any {
		//log.ot('>>getTncLinkList', this.json)
		var list = this.json['tncLinkList'] ?? [];
		return list;
	}

	public getDetailTncHtmlList(): any {
		//log.ot('>>getTncHtmlList', this.json)
		var list = this.json['details']['tncHtml'] ?? {};
		return list;
	}

	public getBottomRemark(): string {
		var box = this.json['details'] ?? {};
		return wording.get(box['bottomRemark'] ?? '');
	}

	public getPlanCardDetailJson(): any {
		var json = this.json['planCardDetail'] ?? {};
		return json;
	}

	/*
    
    
    public getLandingDesc1(){
        return wording.get(this.landingDesc1)
    }
    public getLandingDesc2(){
        return wording.get(this.landingDesc2)
    }*/
}
